import type { PaginationState, Updater } from '@game/ui';
import { create } from 'zustand';

import { marketDefault, type MarketState } from './marketState';

interface Store extends MarketState {
  resetMarket: () => void;
  setBuyOrdersPagination: (updater: Updater<PaginationState>) => void;
  setSellOrdersPagination: (updater: Updater<PaginationState>) => void;
  resetPagination: () => void;
}

export const marketStore = create<Store>((set, get) => ({
  ...marketDefault,
  resetMarket: (): void => {
    set((state) => ({ ...state, ...marketDefault }));
  },
  setBuyOrdersPagination: (updater: Updater<PaginationState>): void => {
    const current = get().buyOrdersPagination;
    const newValue = typeof updater === 'function' ? updater(current) : updater;
    set((state) => ({ ...state, buyOrdersPagination: newValue }));
  },
  setSellOrdersPagination: (updater: Updater<PaginationState>): void => {
    const current = get().sellOrdersPagination;
    const newValue = typeof updater === 'function' ? updater(current) : updater;
    set((state) => ({ ...state, sellOrdersPagination: newValue }));
  },
  resetPagination: (): void => {
    set((state) => ({
      ...state,
      buyOrdersPagination: { pageIndex: 0, pageSize: state.buyOrdersPagination.pageSize },
      sellOrdersPagination: { pageIndex: 0, pageSize: state.sellOrdersPagination.pageSize },
    }));
  },
}));
